"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchInput from "./CreateWaveGroupSearchInput";
import CreateWaveGroupSearchResults, { type CreateWaveGroupSearchResultsLayout } from "./CreateWaveGroupSearchResults";
import { useCreateWaveGroupSearch } from "./useCreateWaveGroupSearch";
export default function CreateWaveGroupSearchField(t0) {
  const $ = _c(43);
  const {
    label,
    defaultLabel,
    disabled,
    selectedGroup,
    allowClear: t1,
    resultsLayout: t2,
    onSelect
  } = t0;
  const allowClear = t1 === undefined ? true : t1;
  const resultsLayout = t2 === undefined ? "popover" : t2;
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);
  let t3;
  if ($[0] !== allowClear || $[1] !== defaultLabel || $[2] !== disabled || $[3] !== onSelect || $[4] !== selectedGroup) {
    t3 = {
      defaultLabel,
      disabled,
      inputRef,
      selectedGroup,
      allowClear,
      onSelect,
      wrapperRef
    };
    $[0] = allowClear;
    $[1] = defaultLabel;
    $[2] = disabled;
    $[3] = onSelect;
    $[4] = selectedGroup;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const search = useCreateWaveGroupSearch(t3);
  const t4 = !!selectedGroup;
  let t5;
  if ($[6] !== disabled || $[7] !== label || $[8] !== search.activeOptionId || $[9] !== search.clearSelection || $[10] !== search.handleInputChange || $[11] !== search.handleKeyDown || $[12] !== search.hasValue || $[13] !== search.inputId || $[14] !== search.inputValue || $[15] !== search.isOpen || $[16] !== search.listboxId || $[17] !== search.onInputFocus || $[18] !== search.showClearButton || $[19] !== t4) {
    t5 = <CreateWaveGroupSearchInput inputRef={inputRef} inputId={search.inputId} listboxId={search.listboxId} activeOptionId={search.activeOptionId} label={label} value={search.inputValue} isOpen={search.isOpen} disabled={disabled} hasValue={search.hasValue} hasSelectedGroup={t4} showClearButton={search.showClearButton} onInputFocus={search.onInputFocus} onInputChange={search.handleInputChange} onInputKeyDown={search.handleKeyDown} onClearSelection={search.clearSelection} />;
    $[6] = disabled;
    $[7] = label;
    $[8] = search.activeOptionId;
    $[9] = search.clearSelection;
    $[10] = search.handleInputChange;
    $[11] = search.handleKeyDown;
    $[12] = search.hasValue;
    $[13] = search.inputId;
    $[14] = search.inputValue;
    $[15] = search.isOpen;
    $[16] = search.listboxId;
    $[17] = search.onInputFocus;
    $[18] = search.showClearButton;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== disabled || $[22] !== resultsLayout || $[23] !== search.activeIndex || $[24] !== search.helperText || $[25] !== search.isFetching || $[26] !== search.isOpen || $[27] !== search.listboxId || $[28] !== search.onOptionSelect || $[29] !== search.searchCriteria || $[30] !== search.setActiveIndex || $[31] !== search.showNoResults || $[32] !== search.suggestions || $[33] !== selectedGroup) {
    t6 = <CreateWaveGroupSearchResults isOpen={search.isOpen} disabled={disabled} layout={resultsLayout} listboxId={search.listboxId} isFetching={search.isFetching} suggestions={search.suggestions} selectedGroup={selectedGroup} activeIndex={search.activeIndex} searchCriteria={search.searchCriteria} showNoResults={search.showNoResults} helperText={search.helperText} onActiveIndexChange={search.setActiveIndex} onOptionSelect={search.onOptionSelect} />;
    $[21] = disabled;
    $[22] = resultsLayout;
    $[23] = search.activeIndex;
    $[24] = search.helperText;
    $[25] = search.isFetching;
    $[26] = search.isOpen;
    $[27] = search.listboxId;
    $[28] = search.onOptionSelect;
    $[29] = search.searchCriteria;
    $[30] = search.setActiveIndex;
    $[31] = search.showNoResults;
    $[32] = search.suggestions;
    $[33] = selectedGroup;
    $[34] = t6;
  } else {
    t6 = $[34];
  }
  let t7;
  if ($[35] !== t5 || $[36] !== t6) {
    t7 = <div className="tw-group tw-relative tw-w-full">{t5}{t6}</div>;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  let t8;
  if ($[38] !== search.helperText) {
    t8 = <p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400">{search.helperText}</p>;
    $[38] = search.helperText;
    $[39] = t8;
  } else {
    t8 = $[39];
  }
  let t9;
  if ($[40] !== t7 || $[41] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-gap-y-2" ref={wrapperRef}>{t7}{t8}</div>;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
}